<template>
  <div>
    <el-container>
      <el-main>
        <div class="mx-auto">
          <h3>直接建立</h3>
        </div>
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="經銷商">
            <selectCompany :filter_all="filter_all" :id.sync="form.company_id" />
          </el-form-item>

          <el-form-item label="期別" prop="period">
            <el-input v-model="form.period" placeholder="如: 11202" />
          </el-form-item>
          <el-form-item label="字軌" prop="front">
            <el-input v-model="form.front" placeholder="如: AA" />
          </el-form-item>
          <el-form-item label="起始號碼" prop="start">
            <el-input v-model="form.start" placeholder="如: 00010001" />
          </el-form-item>
          <el-form-item label="結束號碼" prop="end">
            <el-input v-model="form.end" placeholder="如: 00010010" />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">立即建立</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
        <br />
        <hr />
        <div class="mx-auto">
          <h3>批次上傳</h3>
        </div>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-card>
              <div slot="header">
                <h4 class="h4">經銷商</h4>
                <selectCompany :id.sync="form.company_id" :filter_all="true" />
              </div>
              <el-button type="primary" @click="openSelectFile">點擊上傳檔案</el-button>
              <a @click="downloadExample"> 點擊下載範例 </a>
            </el-card>
          </el-col>
        </el-row>

        <el-dialog :visible.sync="sheetDialogVisible" title="請問是否要以下列資料新增發票？">
          <el-table :data="newInvoice">
            <el-table-column prop="front" label="字軌" />
            <el-table-column prop="start" label="起始號碼" />
            <el-table-column prop="end" label="結束號碼" />
            <el-table-column prop="period" label="發票期別" />
            <el-table-column prop="wholesaler" label="經銷商代號" />
          </el-table>
          <el-button type="primary" @click="confirmUpload">確認上傳</el-button>
          <el-button type="danger" @click="cancelUpload">取消</el-button>
        </el-dialog>
        <input ref="sheetUploadInput" type="file" @change="upload" hidden />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { createInvoices, importInvoices, downloadExample, v2createInvoices } from '@/api/invoice';
import uploadExcel from '@/components/UploadExcel/index.vue';
import selectCompany from '@/components/select/companies';
import { saveAs } from 'file-saver';
import { duration } from 'moment-timezone';

const methods = {
  openSelectFile() {
    this.$refs.sheetUploadInput.value = null;
    this.$refs.sheetUploadInput.click();
  },
  async onSubmit(formName) {
    this.$refs[formName].validate(async (valid) => {
      if (valid) {
        await this.createInvoices();
        this.$refs[formName].resetFields();
      } else {
        return false;
      }
    });
  },
  async upload(event) {
    try {
      const formData = new FormData();
      let file = event.target.files[0];
      formData.append('file', file);
      const res = await importInvoices(formData, this.form.company_id);
      if (res.status > 299) {
        throw new Error(res.message);
      }
      this.newInvoice = res.data;
      this.sheetDialogVisible = true;
    } catch (error) {
      this.$message({
        message: error.message,
        type: 'error',
        showClose: true,
        duration: 60000,
      });
      console.error(error);
    } finally {
      this.$refs.sheetUploadInput.value = null;
    }
  },
  async createInvoices() {
    try {
      this.$message({
        message: '若一次性生成的發票數量較多，可能會需要數分鐘才會回傳結果，請耐心等候。',
        type: 'warning',
        showClose: true,
        duration: 0,
      });
      const res = await v2createInvoices(this.form);
      // console.log(res);
      if (res.status > 299) {
        let err_json = res.message;
        let op_range = `${err_json.op_start}-${err_json.op_end}`;
        let input_range = `${err_json.front}${err_json.input_start}-${err_json.front}${err_json.input_end}`;
        let message = `資料庫中已存在期別為「${err_json.period}」、字軌為「${err_json.front}」且範圍為 ${op_range} 的發票了，您所上傳的發票為 ${input_range}，請修正後重新上傳。`;
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 0,
        });
      } else {
        this.$message({
          message: '建立成功',
          type: 'success',
          duration: 0,
          showClose: true,
        });
      }
    } catch (error) {
      console.error(error);
    }
  },
  cancelUpload() {
    this.newInvoice = [];
    this.$refs.sheetUploadInput.value = null;
    this.sheetDialogVisible = false;
  },
  async confirmUpload() {
    try {
      for (let newInvoice of this.newInvoice) {
        this.form = newInvoice;
        let res = await this.createInvoices();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.newInvoice = [];
      this.$refs.sheetUploadInput.value = null;
      this.sheetDialogVisible = false;
      this.form = {
        front: '',
        start: '',
        end: '',
        period: '',
        company_id: '',
      };
    }
  },
  async downloadExample() {
    downloadExample()
      .then((response) => {
        // create file link in browser's memory
        saveAs(response, '發票字軌範例.csv');
      })
      .catch((e) => console.error(e));
  },
};
export default {
  components: { uploadExcel, selectCompany },
  data() {
    return {
      filter_all: true,
      sheetDialogVisible: false,
      newInvoice: {},
      sheetFormData: new FormData(),
      dialog: false,
      companies: [],
      form: {
        front: '',
        start: '',
        end: '',
        period: '',
        company_id: 1,
      },
      rules: {
        front: [
          { required: true, message: '必填', trigger: 'blur' },
          { min: 2, max: 2, message: '2個英文字母', trigger: 'blur' },
        ],
        start: [
          { required: true, message: '必填', trigger: 'blur' },
          { min: 8, max: 8, message: '8位數數字', trigger: 'blur' },
        ],
        end: [
          { required: true, message: '必填', trigger: 'blur' },
          { min: 8, max: 8, message: '8位數數字', trigger: 'blur' },
        ],
        period: [
          { required: true, message: '必填', trigger: 'blur' },
          { min: 5, max: 5, message: '5位數字年月如 11001', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    'form.front': function () {
      this.form.front = this.form.front.toUpperCase();
    },
  },
  async created() {},
  methods,
};
</script>
<style>
.mx-auto {
  margin: 0 auto;
  text-align: center;
}
</style>
